module.exports = __webpack_public_path__ + "img/dljm.27b057cd.png";